import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { IOperationRuleAlertUser } from "../../../../stores/data/insightAlerts/insightAlertModel";
import { Check, X } from "lucide-react";

const ChannelStatus: React.FC<{
  isAllowed: boolean;
  label: string;
}> = ({ isAllowed, label }) => (
  <Flex align="center" gap={1}>
    <Text fontSize="14px">
      {isAllowed ? (
        <Check size="16px" color="#24954E" />
      ) : (
        <X size="16px" color="#D62222" />
      )}
    </Text>
    <Text fontSize="12px" color={"#57708A"}>
      {label}
    </Text>
  </Flex>
);

export const hasAnyChannelEnabled = (
  user: IOperationRuleAlertUser,
): boolean => {
  return (
    (user?.isWhatsappAllowed ?? false) ||
    (user?.isEmailAllowed ?? false) ||
    (user?.isPushAllowed ?? false)
  );
};

export const createColumns = ({
  t,
  currentUserId,
}: {
  t: (key: string) => string;
  currentUserId?: number;
}) => [
  {
    title: t("userName"),
    dataIndex: "userName",
    width: "40%",
    render: (_: any, record: IOperationRuleAlertUser) => {
      const isDisabled =
        !hasAnyChannelEnabled(record) && record.userId !== currentUserId;

      return (
        <Text
          fontWeight="500"
          color={isDisabled ? "#A0AEC0" : "#3A3A3A"}
          opacity={isDisabled ? 0.5 : 1}
        >
          {record?.userName}
        </Text>
      );
    },
  },
  {
    title: t("enabledDeliveryChannels"),
    dataIndex: "channels",
    width: "60%",
    align: "right" as const,
    render: (_: any, record: IOperationRuleAlertUser) => {
      const isDisabled =
        !hasAnyChannelEnabled(record) && record.userId !== currentUserId;

      return (
        <Flex
          gap={3}
          align="center"
          justify="flex-end"
          opacity={isDisabled ? 0.5 : 1}
        >
          <ChannelStatus
            isAllowed={record?.isWhatsappAllowed ?? false}
            label="WhatsApp"
          />
          <ChannelStatus
            isAllowed={record?.isEmailAllowed ?? false}
            label="Email"
          />
          <ChannelStatus
            isAllowed={record?.isPushAllowed ?? false}
            label="App"
          />
        </Flex>
      );
    },
  },
];
